import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 번역 키 검증 도구
import { validateTranslationsInDevelopment } from './translationValidator';

// 번역 파일을 동적으로 로드
const loadTranslations = async () => {
  try {
    const [ko, en] = await Promise.all([
      import('./locales/ko.json'),
      import('./locales/en.json')
    ]);

    // 번역 파일이 제대로 로드되었는지 확인
    if (!ko.default || !en.default) {
      console.error('Translation files failed to load');
      return false;
    }



    return { ko: ko.default, en: en.default };
  } catch (error) {
    console.error('Error loading translation files:', error);
    return false;
  }
};

// i18n 초기화
const initializeI18n = async () => {
  const translations = await loadTranslations();
  
  if (!translations) {
    console.error('Failed to load translations, using fallback');
    // 기본 번역 데이터로 초기화
    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          ko: { 
            translation: {
              profile: {
                title: '프로필 관리',
                basicInfo: '기본 정보',
                securitySettings: '보안 설정',
                passwordSecurity: '비밀번호 보안',
                passwordSecurityDesc: '정기적으로 비밀번호를 변경하여 계정을 보호하세요.',
                save: '저장',
                changePassword: '비밀번호 변경',
                change: '변경',
                cancel: '취소',
                currentPassword: '현재 비밀번호',
                newPassword: '새 비밀번호',
                confirmPassword: '새 비밀번호 확인',
                bubmyengOptional: '법명 (선택사항)',
                organNameOptional: '소속 (선택사항)',
                updateSuccess: '프로필이 성공적으로 업데이트되었습니다.',
                updateError: '프로필 업데이트에 실패했습니다.',
                passwordChangeSuccess: '비밀번호가 성공적으로 변경되었습니다.',
                passwordChangeError: '비밀번호 변경에 실패했습니다.',
                loginRequired: '로그인이 필요합니다',
                loginRequiredDesc: '프로필을 보려면 먼저 로그인해주세요.',
                backToMain: '메인으로 돌아가기'
              }
            }
          },
          en: { 
            translation: {
              profile: {
                title: 'Profile Management',
                basicInfo: 'Basic Information',
                securitySettings: 'Security Settings',
                passwordSecurity: 'Password Security',
                passwordSecurityDesc: 'Regularly change your password to protect your account.',
                save: 'Save',
                changePassword: 'Change Password',
                change: 'Change',
                cancel: 'Cancel',
                currentPassword: 'Current Password',
                newPassword: 'New Password',
                confirmPassword: 'Confirm New Password',
                bubmyengOptional: 'Dharma Name (Optional)',
                organNameOptional: 'Organization (Optional)',
                updateSuccess: 'Profile updated successfully.',
                updateError: 'Failed to update profile.',
                passwordChangeSuccess: 'Password changed successfully.',
                passwordChangeError: 'Failed to change password.',
                loginRequired: 'Login Required',
                loginRequiredDesc: 'Please log in to view your profile.',
                backToMain: 'Back to Main'
              }
            }
          }
        },
        lng: 'ko',
        fallbackLng: 'ko',
        interpolation: { escapeValue: false },
        debug: process.env.NODE_ENV === 'development',
        react: {
          useSuspense: false,
        },
      });
    return;
  }

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        ko: { translation: translations.ko },
        en: { translation: translations.en },
      },
      lng: 'ko', // 강제로 한국어 설정
      fallbackLng: 'ko',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },
      debug: process.env.NODE_ENV === 'development', // 개발 환경에서 디버그 활성화
      react: {
        useSuspense: false,
      },
      // 번역 키가 없을 때의 처리
      missingKeyHandler: (lng, ns, key, res) => {
        console.warn(`Missing translation key: ${key} for language: ${lng}`);
        return key;
      },
    });

  // i18n 초기화 완료 후 테스트
  i18n.on('initialized', () => {
    // 초기화 완료
  });

  if (process.env.NODE_ENV === 'development') {
    validateTranslationsInDevelopment();
  }
};

// i18n 초기화 실행
initializeI18n();

export default i18n; 